<button mat-button (click)="openSecurity()">
  <mat-icon class="material-icons-outlined">privacy_tip</mat-icon>
  <span>Security & Privacy</span>
</button>
